/* Svensk katalog for locale-reports-labels-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'rep.zeroHidden': 'Kontona har nollsaldo under perioden. Visa dem via filter.',
  'rep.showZero': 'Visa konton med nollsaldo',
  'rep.group.tax': 'SKATTEKOSTNAD',
  'rep.trial.titleHelp': 'Råbalansen listar alla konton i kontoplanen med saldo för vald period. Tryck på en kontorad för att se verifikationerna som är bokförda på kontot.',
  'rep.trial.viewHelp': 'Råbalansen visar som standard bara aktiva konton — konton med saldo eller rörelse. ”Visa även inaktiva konton” tar med resten av kontoplanen, och ”Visa bara konton med rörelse” kräver att kontot är bokfört i perioden. Visa som väljer om beloppen visas i kronor och öre, hela kronor eller hela tusental.',
  'rep.trial.empty': 'Inga bokförda saldon för vald period.',
  'rep.trial.oneSupplier': '1 leverantör',
  'rep.trial.supplierCount': '{n} leverantörer',
  'rep.trial.oneCustomer': '1 kund',
  'rep.trial.customerCount': '{n} kunder',
  'rep.trial.oneOpenCustomerItem': '1 öppen post',
  'rep.trial.openCustomerItems': '{n} öppna poster',
  'rep.trial.customerDifference': 'Andra konteringar / avstämningsdifferens',
  'rep.trial.noCustomerBalances': 'Inga kundsaldon i vald vy.',
  'rep.trial.oneOpenSupplierItem': '1 öppen post',
  'rep.trial.openSupplierItems': '{n} öppna poster',
  'rep.trial.supplierDifference': 'Andra konteringar / avstämningsdifferens',
  'rep.trial.noSupplierBalances': 'Inga leverantörssaldon i vald vy.',
  'rep.trial.exportTitle': 'Råbalans: {column}',
  'rep.group.assets': 'TILLGÅNGAR',
  'rep.group.equityLiabilities': 'EGET KAPITAL / SKULDER',
  'rep.group.operatingIncome': 'RÖRELSEINTÄKTER',
  'rep.group.operatingCosts': 'RÖRELSEKOSTNADER',
  'rep.groupTotal': 'Summa {group}',
  'rep.balance.opening': 'Ingående',
  'rep.balance.movement': 'Förändring',
  'rep.balance.closing': 'Utgående',
  'rep.showAs.withDecimals': 'Kronor och öre',
  'rep.showAs.whole': 'Hela kronor',
  'rep.showAs.thousands': 'Hela tusental',
  'rep.result.titleHelp': 'Resultaträkningen visar intäkterna och kostnaderna i perioden och vad som blir kvar som resultat. Öppna en sektion för att se kontona bakom siffrorna och tryck på en kontorad för att se verifikationerna som är bokförda där.',
  'rep.result.subtitle': 'Börja med sammanfattningen och öppna kontodetaljer vid behov.',
  'rep.result.income': 'Rörelseintäkter',
  'rep.result.costs': 'Rörelsekostnader',
  'rep.result.finance': 'Finansiella poster',
  'rep.result.beforeTax': 'Resultat före skatt',
  'rep.result.noLines': 'Ingen aktivitet på de här kontona ännu.',
  'rep.total': 'Summa',
  'rep.showDetails': 'Visa detaljer',
  'rep.hideDetails': 'Dölj detaljer',
  'rep.shareOfLargest': '{pct} % av största posten',
  'rep.showVouchersFor': 'Visa alla verifikationer på {account}',
  'rep.period.otherYear': 'Visar siffror för räkenskapsåret {year}.',
  'rep.period.singleYear': 'Perioden sträcker sig över två räkenskapsår. Rapporten beräknas per räkenskapsår med ingående balans från årets början, så välj en period inom ett år.',
  'rep.export.busy': 'Exporterar...',
  'rep.export.downloaded': '{format} nedladdad',
  'rep.export.failed': 'Kunde inte exportera rapporten.',
  'rep.export.pdfUnavailable': 'Rapport-PDF är inte kopplad till backend.',
  'rep.export.year': 'År',
  'rep.export.period': 'Period',
  'rep.export.summary': 'Sammanfattning',
  'rep.export.item': 'Post',
  'rep.export.amount': 'Belopp',
  'rep.accountHelp.receivables': 'Kundfordringar är pengar som kunder är skyldiga dig för fakturor som inte är betalda ännu.',
  'rep.accountHelp.bank': 'Bankmedel visar pengar på företagskontot.',
  'rep.accountHelp.payables': 'Leverantörsskulder är fakturor och köp som du är skyldig leverantörer.',
  'rep.accountHelp.outputVat': 'Utgående moms är mervärdesskatt du har tagit ut vid försäljning.',
  'rep.accountHelp.inputVat': 'Ingående moms är mervärdesskatt du har betalat vid köp och normalt kan dra av.',
  'rep.accountHelp.vatSettlement': 'Momsredovisningskonto visar nettomoms du är skyldig eller har att få tillbaka.',
  'rep.accountHelp.vatableSales': 'Momspliktig försäljningsintäkt visar ordinarie försäljning där utgående moms beräknas.',
  'rep.accountHelp.group.asset': 'Tillgångskonto: värden som företaget äger eller har att fordra.',
  'rep.accountHelp.group.equityLiability': 'Eget kapital eller skulder: finansiering, skyldiga belopp och avräkningsposter.',
  'rep.accountHelp.group.income': 'Intäktskonto: försäljning och andra intäkter i verksamheten.',
  'rep.accountHelp.group.goods': 'Varukostnad: kostnader kopplade till varor, råvaror eller vidareförsäljning.',
  'rep.accountHelp.group.payroll': 'Personalkostnad: lön, semesterersättning och personalrelaterade förmåner.',
  'rep.accountHelp.group.operating': 'Rörelsekostnad: kostnader för att driva verksamheten.',
  'rep.accountHelp.group.finance': 'Finans- eller skattekonto: räntor, finansiella poster eller skattekostnad.',
  'rep.accountHelp.other': 'Konto {account} i kontoplanen.',
  'rep.accountHelp.openVouchers': 'Tryck på kontoraden för att se alla verifikationer som är bokförda på det här kontot.',
  'rep.dimensions.title': 'Projekt och avdelning',
  'rep.dimensions.help': 'Filtrera rapporten utan att ändra källdata. Hela verifikationen behålls, inklusive motposterna.',
  'rep.dimensions.project': 'Projekt',
  'rep.dimensions.department': 'Avdelning',
  'rep.dimensions.all': 'Alla',
  'rep.dimensions.unassigned': 'Ej fördelat',
  'rep.incompleteBasisTitle': 'Bokföringsunderlaget är ofullständigt',
  'rep.incompleteBasisText': 'Rapporten visas inte som komplett eftersom journaltäckningen eller nödvändigt ingående underlag inte är dokumenterat. Tillgängliga data är bevarade för kontroll.',
  'rep.importedBasisTitle': 'Importerad bokföringsstatistik.',
  'rep.importedBasisText': 'Siffrorna kommer från kontrollerad importerad kontostatistik, inte journalhändelser i Plumme. De är inte certifierade och kan inte användas för inlämning, betalningsgodkännande eller bokslut.',
  'rep.importedBasisExport': 'Kontrollerad importerad kontostatistik; inte journalfullständig eller certifierad.',
});
